<template>
  <div>
    <Card>
      <div class="search-con search-con-top">
        <Form :model="form" :label-width="80" inline>
          <FormItem label="姓名">
            <Input v-model="form.name"></Input>
          </FormItem>
          <FormItem label="身份证">
            <Input v-model="form.cardNo"></Input>
          </FormItem>
        </Form>
        <div class="toolbar">
          <Button type="primary" icon="md-add" @click="handleCreate">上传流水</Button>
          <Button type="primary" icon="md-add" @click="handleMultiCustomCreate">多人流水上传</Button>
<!--          <Button type="primary" icon="md-add" @click="handleMultiCustomLtdCreate">个人及公司流水上传</Button>-->
          <Button @click="handleSearch" icon="md-search" class="search-btn" type="primary">搜索</Button>
        </div>
      </div>
      <Tables ref="tables" v-model="tableData" :columns="columns" @on-search="handleSearch"
              @on-update="handleUpdate" @on-detail="handleDetail" @on-selection-change="selectionChange"/>
    </Card>
    <uploadBill ref="uploadBillRef" @handle-search="handleSearch"></uploadBill>
    <uploadBillMultiCustom ref="uploadBillMultiCustomRef" @handle-search="handleSearch"></uploadBillMultiCustom>
    <uploadBillMultiCustomLtd ref="uploadBillMultiCustomLtdRef" @handle-search="handleSearch"></uploadBillMultiCustomLtd>
    <zhixiReport ref="zhixiReportRef" @handle-search="handleSearch"></zhixiReport>
    <aiReport ref="aiReportRef" @handle-search="handleSearch"></aiReport>
  </div>
</template>

<script>
import uploadBill from './upload-bill.vue'
import uploadBillMultiCustom from './upload-bill-multi-custom.vue'
import uploadBillMultiCustomLtd from './upload-bill-multi-customltd.vue'
import zhixiReport from './zhixi-report'
import aiReport from './ai-report'
import { getIds, getToken } from '@/libs/util'
export default {
  name: 'custominfo-list',
  components: {
    uploadBill, zhixiReport, uploadBillMultiCustom, uploadBillMultiCustomLtd, aiReport
  },
  data () {
    return {
      columns: [
        { title: '姓名', key: 'name' },
        { title: '身份证', key: 'cardNo' },
        { title: '第一次', key: 'firstTime' },
        { title: '最近一次', key: 'lastTime' },
        { title: '总支出', key: 'payMoney' },
        { title: '总收入', key: 'incoming' },
        {
          title: '状态',
          key: 'status',
          render: (h, params) => {
            return h('span', params.row.status === 2 ? '处理中' : (params.row.status === 200 ? '处理完成' : '处理失败'))
          }
        },
        {
          title: '操作',
          key: 'handle',
          minWidth: 200,
          button: [
            (h, params, vm) => {
              return h('Button', {
                props: {
                  type: 'primary',
                  size: 'small',
                  icon: 'md-construct'
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.handleDetail(params.row)
                  }
                }
              }, '分析报告')
            },
            (h, params, vm) => {
              return h('Button', {
                props: {
                  type: 'primary',
                  size: 'small',
                  icon: 'md-attach'
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.refreshType(params.row)
                  }
                }
              }, '刷新')
            },
            (h, params, vm) => {
              if (params.row.status === 200) {
                return h('Button', {
                  props: {
                    type: 'primary',
                    size: 'small',
                    icon: 'md-construct'
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      this.ShareReport(params.row)
                    }
                  },
                  ref: 'copyButton'
                }, '分享')
              }
            },
            (h, params, vm) => {
              if (params.row.status === 200) {
                return h('Button', {
                  props: {
                    type: 'primary',
                    size: 'small',
                    icon: 'md-construct'
                  },
                  style: {
                    marginRight: '5px',
                    marginTop: '3px'
                  },
                  on: {
                    click: () => {
                      this.AiReport(params.row)
                    }
                  },
                  ref: 'copyButton'
                }, 'AI画像')
              }
            }
          ]
        }
      ],
      tableData: {
        rows: [],
        total: 0
      },
      form: {
        map: {}
      },
      selectedData: [],
      infoIsShow: false
    }
  },
  methods: {
    handleDetail (param) {
      console.info(param)
      console.info('===============================123')
      this.$refs.zhixiReportRef.openModel('detail', param)
    },
    refreshType (param) {
      this.G('custominfo/refreshType/' + param.id).then(data => {
        this.$Message.info(data)
      })
    },
    ShareReport: function (param) {
      this.G('custominfo/getReport/' + param.id + '/web?token=' + getToken()).then(data => {
        if (navigator.clipboard && window.isSecureContext) {
          navigator.clipboard.writeText(data)
            .then(() => {
              this.$Message.success('成功复制到剪贴板！')
            }, (err) => {
              console.error('复制失败', err)
              this.$Message.error('复制到剪贴板失败，请重试！')
            })
        } else {
          const textArea = document.createElement('textarea')
          textArea.value = data
          textArea.style.position = 'absolute'
          textArea.style.opacity = '0'
          textArea.style.left = '-999999px'
          textArea.style.top = '-999999px'
          document.body.appendChild(textArea)
          textArea.focus()
          textArea.select()
          if (!document.execCommand('copy')) {
            this.$Message.error('复制到剪贴板失败，请重试！')
          } else {
            this.$Message.success('成功复制到剪贴板！')
          }
          textArea.remove()
        }
      }
      )
    },
    AiReport: function (param) {
      this.$refs.aiReportRef.openModel('detail', param)
    },
    handleCreate () {
      this.$refs.uploadBillRef.openModel('create')
    },
    handleMultiCustomCreate () {
      this.$refs.uploadBillMultiCustomRef.openModel('create')
    },
    handleMultiCustomLtdCreate () {
      this.$refs.uploadBillMultiCustomLtdRef.openModel('create')
    },
    handleDelete () {
      this.D('custominfo', getIds(this.selectedData)).then(data => {
        this.$Message.success(data)
        this.handleSearch()
      })
    },
    handleUpdate () {

    },
    selectionChange (selection) {
      this.selectedData = selection
    },
    handleSearch (page, pageSize) {
      if (isNaN(page)) {
        page = 1
      }
      this.form.type = 1
      let param = {
        page: page,
        pageSize: pageSize,
        model: this.form,
        map: this.form.map,
        sort: 'MDF_TIME'
      }
      this.L('custominfo', param).then(data => {
        this.tableData = data
      })
    }
  },
  mounted () {
    this.handleSearch()
  }
}
</script>
